import InternalStaticAnchor from 'models/application/anchor/types/internalStatic/InternalStatic';

export default class InternalStaticAnchorBattles extends InternalStaticAnchor {
	_pattern = '/battles';
}
